import React from "react"
import PropTypes from "prop-types"
import { StyledH2 } from "./styles"

const H2 = ({ children, ...rest }) => <StyledH2 {...rest}>{children}</StyledH2>

H2.propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["default", "small", "medium", "large"]),
  variant: PropTypes.oneOf(["default", "primary", "secondary", "content"]),
  marginless: PropTypes.bool
}

H2.defaultProps = {
  size: "default",
  variant: "default",
  marginless: false
}

export default H2
